import axios from 'axios';
import {
    FORM_RESPONSE_LIST_REQUEST,
    FORM_RESPONSE_LIST_SUCCESS,
    FORM_RESPONSE_LIST_FAIL,
    FORM_RESPONSE_LIST_RESET,
    FORM_RESPONSE_DETAILS_REQUEST,
    FORM_RESPONSE_DETAILS_SUCCESS,
    FORM_RESPONSE_DETAILS_FAIL,
    FORM_RESPONSE_CREATE_REQUEST,
    FORM_RESPONSE_CREATE_SUCCESS,
    FORM_RESPONSE_CREATE_FAIL,
    FORM_RESPONSE_CREATE_RESET,
    FORM_RESPONSE_UPDATE_REQUEST,
    FORM_RESPONSE_UPDATE_SUCCESS,
    FORM_RESPONSE_UPDATE_FAIL,
    FORM_RESPONSE_UPDATE_RESET,
    FORM_RESPONSE_DELETE_REQUEST,
    FORM_RESPONSE_DELETE_SUCCESS,
    FORM_RESPONSE_DELETE_FAIL,
    FORM_RESPONSE_DELETE_RESET,
    FORM_RESPONSE_BY_PATIENT_REQUEST,
    FORM_RESPONSE_BY_PATIENT_SUCCESS,
    FORM_RESPONSE_BY_PATIENT_FAIL,
    FORM_RESPONSE_LIST_BYIDS_REQUEST,
    FORM_RESPONSE_LIST_BYIDS_SUCCESS,
    FORM_RESPONSE_LIST_BYIDS_FAIL,
    FORM_RESPONSE_LIST_BYIDS_RESET,
    FORM_RESPONSE_DTO_REQUEST,
    FORM_RESPONSE_DTO_SUCCESS,
    FORM_RESPONSE_DTO_FAIL,
    FORM_RESPONSE_DTO_RESET
} from '../constants/formResponseConstants';

const getAuthConfig = (token) => ({
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
});

const formatErrorMessage = (error) => {
    const errorMessages = [];
    if (error.response?.data) {
        if (error.response.data.errors) {
            Object.entries(error.response.data.errors).forEach(([key, value]) => {
                errorMessages.push(`${key}: ${value[0]}`);
            });
        }
        if (error.response.data.detail) {
            errorMessages.push(`Detail: ${error.response.data.detail}`);
        }
        if (error.response.data.message) {
            errorMessages.push(`Message: ${error.response.data.message}`);
        }
    }
    return errorMessages.length > 0 ? errorMessages : [error.message || "An error occurred, please try again later"];
};

export const listFormResponses = (filter) => async (dispatch, getState) => {
    try {
        dispatch({ type: FORM_RESPONSE_LIST_REQUEST });
        const { userLogin: { userInfo } } = getState();
        
        const config = {
            ...getAuthConfig(userInfo.token),
            params: filter || {}
        };
        
        const { data } = await axios.get('/dotnet_api/v1/FormResponse/all', config);
        dispatch({ type: FORM_RESPONSE_LIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FORM_RESPONSE_LIST_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const getFormResponseDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: FORM_RESPONSE_DETAILS_REQUEST });
        const { userLogin: { userInfo } } = getState();
        
        const { data } = await axios.get(
            `/dotnet_api/v1/FormResponse/${id}`,
            getAuthConfig(userInfo.token)
        );
        
        dispatch({ type: FORM_RESPONSE_DETAILS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FORM_RESPONSE_DETAILS_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const getFormResponsesByPatient = (patientId) => async (dispatch, getState) => {
    try {
        dispatch({ type: FORM_RESPONSE_BY_PATIENT_REQUEST });
        const { userLogin: { userInfo } } = getState();
        
        const { data } = await axios.get(
            `/dotnet_api/v1/FormResponse/patient/${patientId}`,
            getAuthConfig(userInfo.token)
        );
        
        dispatch({ type: FORM_RESPONSE_BY_PATIENT_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FORM_RESPONSE_BY_PATIENT_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const createFormResponse = (changes) => async (dispatch, getState) => {
    try {
        dispatch({ type: FORM_RESPONSE_CREATE_REQUEST });
        const { userLogin: { userInfo } } = getState();
        
        const { data } = await axios.post(
            '/dotnet_api/v1/FormResponse',
            changes,
            getAuthConfig(userInfo.token)
        );
        
        dispatch({ type: FORM_RESPONSE_CREATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FORM_RESPONSE_CREATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const updateFormResponse = (id, changes) => async (dispatch, getState) => {
    try {
        dispatch({ type: FORM_RESPONSE_UPDATE_REQUEST });
        const { userLogin: { userInfo } } = getState();
        
        const { data } = await axios.patch(
            `/dotnet_api/v1/FormResponse/${id}`,
            changes,
            getAuthConfig(userInfo.token)
        );
        
        dispatch({ type: FORM_RESPONSE_UPDATE_SUCCESS, payload: data });
        dispatch({ type: FORM_RESPONSE_DETAILS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FORM_RESPONSE_UPDATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const deleteFormResponse = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: FORM_RESPONSE_DELETE_REQUEST });
        const { userLogin: { userInfo } } = getState();
        
        await axios.delete(
            `/dotnet_api/v1/FormResponse/${id}`,
            getAuthConfig(userInfo.token)
        );
        
        dispatch({ type: FORM_RESPONSE_DELETE_SUCCESS });
    } catch (error) {
        dispatch({
            type: FORM_RESPONSE_DELETE_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const resetFormResponseDelete = () => ({ type: FORM_RESPONSE_DELETE_RESET });

export const listFormResponsesByIds = (ids) => async (dispatch, getState) => {
    try {
        dispatch({ type: FORM_RESPONSE_LIST_BYIDS_REQUEST });
        const { userLogin: { userInfo } } = getState();
        
        if (!ids || ids.length === 0) {
            dispatch({
                type: FORM_RESPONSE_LIST_BYIDS_SUCCESS,
                payload: []
            });
            return;
        }
        
        const { data } = await axios.post(
            '/dotnet_api/v1/FormResponse/ids/all',
            ids,
            getAuthConfig(userInfo.token)
        );
        
        dispatch({ type: FORM_RESPONSE_LIST_BYIDS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FORM_RESPONSE_LIST_BYIDS_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const loadFormResponseDto = () => async (dispatch, getState) => {
    try {
        dispatch({ type: FORM_RESPONSE_DTO_REQUEST });
        const { userLogin: { userInfo } } = getState();
        
        const { data } = await axios.get(
            '/dotnet_api/v1/FormResponse/dto',
            getAuthConfig(userInfo.token)
        );
        
        dispatch({ type: FORM_RESPONSE_DTO_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: FORM_RESPONSE_DTO_FAIL,
            payload: formatErrorMessage(error)[0]
        });
    }
};

export const getFormResponseByEntityAndForm = (entityType, entityId, formId) => async (dispatch, getState) => {
    try {
        dispatch({ type: FORM_RESPONSE_DETAILS_REQUEST });
        const { userLogin: { userInfo } } = getState();
        
        const { data } = await axios.get(
            `/dotnet_api/v1/FormResponse/entity/${entityType}/${entityId}/form/${formId}`,
            getAuthConfig(userInfo.token)
        );
        
        // The backend returns an array, get the first (most recent) one
        const response = Array.isArray(data) && data.length > 0 ? data[0] : null;
        dispatch({ type: FORM_RESPONSE_DETAILS_SUCCESS, payload: response });
        return response;
    } catch (error) {
        // If 404, it means no form response exists yet - this is not an error
        if (error.response?.status === 404) {
            dispatch({ type: FORM_RESPONSE_DETAILS_SUCCESS, payload: null });
            return null;
        }
        dispatch({
            type: FORM_RESPONSE_DETAILS_FAIL,
            payload: formatErrorMessage(error)[0]
        });
        return null;
    }
};

